import { defineMessages } from 'react-intl';

export default defineMessages({
  billingSnackbarInfoEditedSuccessfully: {
    defaultMessage: 'Billing info edited successfully.',
    description: 'Billing snackbar - Billing info edited successfully',
    id: 'billingSnackbarInfoEditedSuccessfully',
  },
});
